<script lang="ts">
    import LastVisited from "../../components/LastVisited.svelte";
    import DashboardCard from "../../components/DashboardCard.svelte";
    import WidthBox from "../../components/WidthBox.svelte";
    import { t } from "@lernetz/svelte-translate";
    import { flinkGateway, setupSharedProps, sharedProps } from "../../services";

    setupSharedProps();

</script>



<WidthBox>
    <div class="flex mt-32">
        <div class="flex-1">
            <!-- last visited grid -->
            <LastVisited></LastVisited>
        </div>
    </div>
    <div class="flex mt-32">
        <div class="flex-1">
            <h1 class="text-14 text-almost-black">{$t("learn")}</h1>
            <div class="mt-16 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-16 sm:gap-24 content-center">
                <DashboardCard to="/courses" title="courses" image="modules.png"></DashboardCard>
                <DashboardCard to="/houses" title="houses" image="houses.png"></DashboardCard>
                <DashboardCard to="/library" title="library" image="library.png"></DashboardCard>
                <a href='https://polybauuzwil.sharepoint.com/sites/Lernflink-Lernressourcen/Freigegebene%20Dokumente/Forms/AllItems.aspx?viewid=078d2833%2Df9a6%2D446c%2Db433%2Dd5a77a3533e9&p=true&ga=1' target="_blank">
                    <div class="h-[320px] rounded-2xl flex flex-col items-center transition-all duration-200 bg-light-grey hover:bg-medium-grey">
                        <div class="font-bold text-18 mt-32 text-center">
                            {$t('general documents')}
                        </div>
                        <img
                            alt={$t('general documents')}
                            class="object-contain h-240"
                            src="/images/general-documents.png"
                        />
                    </div>
                </a>
            </div>
        </div>
    </div>
</WidthBox>

